import { render } from "./InfoPricesNodeView.vue?vue&type=template&id=40068b78&scoped=true"
import script from "./InfoPricesNodeView.vue?vue&type=script&lang=js"
export * from "./InfoPricesNodeView.vue?vue&type=script&lang=js"

import "./InfoPricesNodeView.vue?vue&type=style&index=0&id=40068b78&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40068b78"]])

export default __exports__